import EventImg1 from "../assets/images/Events/imac2026.jpeg";
import EventImg3 from "../assets/images/Events/event3.jpg";
import EventImg4 from "../assets/images/Events/event4.jpg";
import EventImg5 from "../assets/images/Events/aslm-20206-event.jpeg";
import EventImg6 from "../assets/images/Events/rootsIX-events.jpeg";
import EventImg7 from "../assets/images/Events/acsicon-event.jpeg";

const eventsData = [
    {
        id: "ACSICON",
        title: "ACSICON 2026",
        image: EventImg7,
        date: "3rd To 5th September , 2026",
        location: "Grand Hyatt, Goa, India",
        shortDesc: "Step into India’s most awaited conference for Dermatologists • Aesthetic Experts • Cosmetologists.",
        description: `
      “Discover the latest in: • Advanced Aesthetic Treatments • Laser & Energy-Based Technologies • Hair Restoration Innovations • Anti-Aging & Skin Rejuvenation • Regenerative Medicine (Exosomes, PRP & more)`,
        document: "../assets/doc/Biopharmacieaa-Brochure.pdf"
    },
    {
        id: "ROOTS-IX",
        title: "ROOTS-IX Conference 2026",
        image: EventImg6,
        date: "June 26–28 , 2026",
        location: "Dr. D.Y. Patil Vidyapeeth Auditorium, Pimpri Colony, Pune, Maharashtra",
        shortDesc: "A National Conference on Clinical Dermatology and Therapeutics returns with its ninth edition.",
        description: `
      “Organize annual conferences under the banner of "Roots," bringing together dermatologists from around the world to share knowledge, network, and discuss the latest trends and research in dermatology.
       Provide a platform for presenting groundbreaking research, new treatment methodologies, and case studies.”
    `,
        document: "../assets/doc/Biopharmacieaa-Brochure.pdf"
    },
    {
        id: "ASLMS-2026",
        title: "ASLMS Annual Conference 2026",
        image: EventImg5,
        date: "May 7–9 , 2026",
        location: "Savannah Convention Center",
        shortDesc: "where innovation meets expertise.",
        description: `
      “Advancing the future of laser and aesthetic medicine…
with global leaders, breakthrough technologies, and powerful insights.”
    `,
        document: "../assets/doc/Biopharmacieaa-Brochure.pdf"
    },
    {
        id: "imcas-2026",
        title: "IMCAS World Congress",
        image: EventImg1,
        date: "January 29-31, 2026",
        location: "Paris ",
        shortDesc: "Revolution in aesthetic dermatology.",
        description: `
      Join the IMCAS World Congress in Paris from January 29th to 31st, featuring the Eiffel Tower in the background.
      It highlights partner companies and their booth numbers, including DEKA, Endymed, Simildiet, Skymedic, Arthrex, and QuantifiCare.
    `,
        document: "../assets/doc/Biopharmacieaa-Brochure.pdf"
    },
    {
        id: "imcas-2025",
        title: "IMCAS 2025",
        image: EventImg3,
        date: "March 7-11, 2025",
        location: "Orlando, Florida",
        shortDesc: "International Master Course on Aging Science.",
        description: `
      We at Biopharmacieaa aim to enhance the understanding, management,
      and treatment of skin and hair concerns using evidence-based therapy.
      This global conference allows us to showcase innovation and science.
    `,
        document: "../assets/doc/Biopharmacieaa-Brochure.pdf"
    },
    {
        id: "root-2025",
        title: "ROOT Conference",
        image: EventImg4,
        date: "April 15-18, 2025",
        location: "Dubai, UAE",
        shortDesc: "Revolution in aesthetic dermatology.",
        description: `
      ROOT conference brings leading dermatologists and aesthetic experts
      under one roof to explore new treatment technologies and methods.
    `,
        document: "../assets/doc/Biopharmacieaa-Brochure.pdf"
    },
];

export default eventsData;
